/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarContact_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_user">;
    readonly " $refType": "PdpRespSidebarContact_user";
};
export type PdpRespSidebarContact_user$data = PdpRespSidebarContact_user;
export type PdpRespSidebarContact_user$key = {
    readonly " $data"?: PdpRespSidebarContact_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarContact_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarContact_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '6d8d2c9b5051683a29be668aabdbfcc4';
export default node;
